import { ref } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import { alertService } from '@/services/alertService';

/**
 * Shared composable for marking an alert as read.
 * Used by AlertBell (dropdown) and FleetAlertManagement (table).
 *
 * - Tracks in-progress IDs via markingAsReadIds (muted state in UI)
 * - Calls the API, then updates the store locally (no HTTP refetch)
 * - MARK_ALERT_READ  → removes the alert from the bell dropdown list
 * - DECREMENT_UNREAD_COUNT → decrements the badge counter by 1
 */
export function useMarkAlertAsRead() {
  const store = useStore();
  const toast = useToast();
  const markingAsReadIds = ref([]);
  const MUTED_MIN_MS = 500;

  async function markAlertAsRead(alertId) {
    if (markingAsReadIds.value.includes(alertId)) return;

    markingAsReadIds.value = [...markingAsReadIds.value, alertId];

    try {
      await Promise.all([
        alertService.markAsRead(alertId),
        new Promise((resolve) => setTimeout(resolve, MUTED_MIN_MS)),
      ]);

      store.commit('alert/MARK_ALERT_READ', alertId);
      store.commit('alert/DECREMENT_UNREAD_COUNT');

      // toast.success('Alert marked as read');
    } catch (error) {
      console.error('Failed to mark alert as read:', error);
      toast.error('Failed to mark alert as read');
      throw error;
    } finally {
      markingAsReadIds.value = markingAsReadIds.value.filter((i) => i !== alertId);
    }
  }

  return { markingAsReadIds, markAlertAsRead };
}
